import {
    actionCreator,
    API_URL,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    jsonApiHeader,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
} from '../../../../../../../actions/utilAction';

export {
    jsonApiHeader,
    showWarningMessage,
    showErrorMessage,
    actionCreator,
    checkHttpStatus,
    create_post_data,
    createSearchUrl,
    showSuccessMessage
};

export const POST_NOTES_API = `${API_URL}/api/PatientNotes/SavePatientNote`;
export const GET_NOTES_LIST_API = `${API_URL}/api/PatientNotes/GetPatientNotes`;
export const GET_NOTES_DETAIL_API = `${API_URL}/api/PatientNotes/GetPatientNoteById`;
export const DELETE_NOTES_API = `${API_URL}/api/PatientNotes/DeletePatientNote`;
export const POST_MARKEDASREVIEWED_NOTES_API = `${API_URL}/api/PatientNotes/MarkedAsReviewPatientNote`;

export const NotesActionTypes = {
    save_Notes: createRequestActionTypes('SAVE_NOTES'),
    get_notesList: createRequestActionTypes('GET_NOTESLIST'),
    get_notesDetail: createRequestActionTypes('GET_NOTESDETAIL'),
    delete_Notes: createRequestActionTypes('DELETE_NOTES'),
    markedAsReviewed_Notes: createRequestActionTypes('MARKEDASREVIEWED_NOTES'),
};

export const MODULE = 'DCPATIENT_NOTES';


// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/Notes/constants/ApiConstants.js